module.exports = __webpack_public_path__ + "img/icon-checked.3efb2dcd.png";